import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { NgTemplateOutlet } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { HistoryMode } from '../../core/services/HistoryMode';
import { ComponentLocationStrategy } from '../../shared/services/location-strategy/component-location-strategy';
import { GrundstueckBeschreibungLocationStrategy } from '../../shared/services/location-strategy/grundstueck-detail-beschreibung-location-strategy.';
import { BeschreibungTableWrapperComponent } from '../../shared/components/table/beschreibung-table-wrapper.component';
import { ListLoaderWrapperComponent } from '../../shared/components/list-loader-wrapper/list-loader-wrapper.component';
import { HistoryDirective } from '../../shared/directives/history.directive';
import { DecimalHochkommaPipe } from '../../shared/pipes/simple/decimalHochkomma.pipe';
import { AbstractComponent } from '../../shared/components/abstract-component/abstract.component';
import { GrundstueckId } from '../../core/gb-api';
import { ListLoader } from '../../shared/components/list-loader/list-loader';
import { ListLoaderObservable } from '../../shared/components/list-loader/list-loader-observable';
import { AvflaecheService, FieldMetaData, GrundstueckFlaecheMasterDetailEntryMeta } from '../../core/av-api';
import { TimepointService } from '../../core/services/timepoint.service';
import { tap } from 'rxjs/operators';
import { AppConfigService } from '../../core/services/app-config.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'cap-grundstueckflaeche-icp',
  templateUrl: './grundstueckflaeche-icp.component.html',
  providers: [{ provide: ComponentLocationStrategy, useClass: GrundstueckBeschreibungLocationStrategy }],
  imports: [
    BeschreibungTableWrapperComponent,
    ListLoaderWrapperComponent,
    NgTemplateOutlet,
    HistoryDirective,
    TranslatePipe,
    DecimalHochkommaPipe
  ]
})
export class GrundstueckflaecheIcpComponent extends AbstractComponent implements OnInit, OnDestroy {
  _grundstueckId: GrundstueckId;
  flaechenListLoader: ListLoader<GrundstueckFlaecheMasterDetailEntryMeta>;

  historischeDatenSubscription: Subscription;

  translateKey: string;
  hasParzellenindex: boolean;
  showQualitaetAV: boolean;

  @Input()
  set flaechenMaessigNichtAusgeschieden(notAusgeschieden: boolean) {
    this.translateKey = notAusgeschieden ? 'FlaecheNichtAusgeschieden' : 'Keine';
  }

  constructor(
    private flaecheService: AvflaecheService,
    private timepointService: TimepointService,
    private appConfigService: AppConfigService
  ) {
    super();
    keysToTranslate<string>(['FlaecheNichtAusgeschieden']);
  }

  ngOnInit(): void {
    this.historischeDatenSubscription = this.appConfigService.einstellungHistorischeDaten$.subscribe(() => {
      this.update();
    });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.historischeDatenSubscription?.unsubscribe();
  }

  @Input()
  set grundstueckId(value: GrundstueckId) {
    this._grundstueckId = value;
    if (!value) {
      return;
    }
  }

  get grundstueckId(): GrundstueckId {
    return this._grundstueckId;
  }

  update(): void {
    const historischeDaten = HistoryMode.HistoryMode.OHNE_HIST_MIT_GESCHAEFTSAENDERUNGEN;
    const timepointCtx = this.timepointService.timepointCtx;
    const observable = this.flaecheService
      .loadGrundstueckFlaecheSichtGrundstueck(this._grundstueckId.id, timepointCtx.timepointIso, timepointCtx.timepointId, historischeDaten)
      .pipe(
        tap((entries: Array<GrundstueckFlaecheMasterDetailEntryMeta>) => {
          this.setHasParzellenindex(entries);
        })
      );
    this.flaechenListLoader = new ListLoaderObservable<GrundstueckFlaecheMasterDetailEntryMeta>(undefined, 1, observable);
  }

  private setHasParzellenindex(entries: Array<GrundstueckFlaecheMasterDetailEntryMeta>): void {
    if (entries.length > 0) {
      this.hasParzellenindex = entries[0].versions[0].mParzellenindex.access !== FieldMetaData.AccessEnum.DEACTIVATED;
    }
  }
}
